import {
    ADMINGETLANGUAGEMAPPINGLIST_SUCCESS,
    ADMINGETLANGUAGEMAPPINGLIST_FAILED,
    RESET_ADMINGETLANGUAGEMAPPINGLIST,
    LOADING_ADMINGETLANGUAGEMAPPINGLIST,
    NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETLANGUAGEMAPPINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGEMAPPINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGEMAPPINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETLANGUAGEMAPPINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};